import React, { useState } from "react";
import { C, RFLogo } from "../theme";
import { fmt, fmtD, Tag, Btn, Inp, Sel, getAppCopy } from "../shared";
import { PLANS } from "../data";

export const PrestatairPortal = ({ prest, onLogout, onSaveProfile, locale = "fr" }) => {
  const copy = getAppCopy(locale);
  const [tab, setTab]   = useState("profil");
  const [notice, setNotice] = useState("");
  const [profile, setProfile] = useState({
    nom: prest.nom, cat: prest.cat, ville: prest.ville, desc: prest.desc,
    tel: prest.tel, email: prest.email, tarif: prest.tarif,
    services: prest.services || prest.desc,
  });

  const plan     = PLANS[prest.plan] || PLANS.decouverte;
  const isEssai  = prest.plan === "essai";
  const trialDay = prest.trialDay || 1;
  const trialLeft = 14 - trialDay;

  const demandes = [
    {id:1,syndic:"Rés. Les Orangers",date:"2024-03-20",desc:"Nettoyage mensuel parties communes",statut:"En attente"},
    {id:2,syndic:"Rés. Al Amal",     date:"2024-03-18",desc:"Nettoyage après travaux",           statut:"Accepté"},
    {id:3,syndic:"Rés. Ryad",        date:"2024-03-15",desc:"Nettoyage vitres cage escalier",     statut:"Terminé"},
  ];
  const TABS = [{k:"profil",i:"👤",l:copy.myProfile},{k:"demandes",i:"📋",l:copy.requests},{k:"stats",i:"📊",l:copy.statistics},{k:"abonnement",i:"💳",l:"Abonnement"}];

  return (
    <div style={{minHeight:"100vh",background:C.bg}}>
      {/* Trial banner */}
      {isEssai && (
        <div style={{background:`linear-gradient(90deg,${C.teal},#0ba882)`,padding:"10px 34px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:18}}>🚀</span>
            <p style={{color:"#fff",fontWeight:600,fontSize:14}}>
              Essai gratuit — Jour <strong>{trialDay}/14</strong> · Il vous reste <strong>{trialLeft} jour(s)</strong> d'accès complet
            </p>
          </div>
          <button className="btn" style={{padding:"7px 18px",background:"#fff",color:C.teal,borderRadius:10,fontWeight:700,fontSize:13}}>
            Passer Pro →
          </button>
        </div>
      )}
      <div style={{background:C.navy,height:62,display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 34px",boxShadow:"0 2px 20px rgba(11,19,51,.22)",position:"sticky",top:0,zIndex:50}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <RFLogo size={34} />
          <div>
            <p style={{fontFamily:"Syne",fontWeight:800,color:"#fff",fontSize:15,lineHeight:1}}>RésiFlow</p>
            <p style={{color:"rgba(255,255,255,.35)",fontSize:11}}>{copy.providerWorkspace}</p>
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:14}}>
          <span className="plan-badge" style={{background:plan.bg,color:plan.color,fontSize:12}}>
            {plan.icon} {plan.label}
          </span>
          <p style={{color:"#fff",fontWeight:600,fontSize:13}}>{prest.nom}</p>
          <button className="btn" onClick={onLogout}
            style={{padding:"6px 14px",borderRadius:9,border:"1px solid rgba(255,255,255,.2)",background:"transparent",color:"rgba(255,255,255,.55)",fontSize:13,fontWeight:600}}>
            Déconnexion
          </button>
        </div>
      </div>

      <div style={{padding:"26px 34px"}}>
        <div style={{display:"flex",gap:4,marginBottom:24,background:C.card,padding:5,borderRadius:13,width:"fit-content",boxShadow:"0 2px 10px rgba(11,19,51,.05)"}}>
          {TABS.map(t => (
            <button key={t.k} className="btn" onClick={() => setTab(t.k)}
              style={{padding:"7px 16px",borderRadius:9,fontSize:13,fontWeight:600,
                background:tab===t.k?C.teal:"transparent",color:tab===t.k?"#fff":C.muted,
                display:"inline-flex",alignItems:"center",gap:5}}>
              {t.i} {t.l}
            </button>
          ))}
        </div>

        {tab === "profil" && (
          <div className="fi" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
            <div style={{background:C.card,borderRadius:16,padding:24,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
              <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:20}}>
                <div style={{width:56,height:56,borderRadius:14,background:C.tealL,display:"flex",alignItems:"center",justifyContent:"center",fontSize:26}}>🔧</div>
                <div>
                  <h3 style={{fontSize:18,fontWeight:700,color:C.text}}>{prest.nom}</h3>
                  <p style={{fontSize:13,color:C.muted,marginTop:3}}>{prest.cat} · {prest.ville}</p>
                </div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:12}}>
                {stars(prest.note)}
                <span style={{fontSize:14,fontWeight:700,color:C.text}}>{prest.note}</span>
                <span style={{fontSize:12,color:C.muted}}>({prest.avis} avis)</span>
              </div>
              <p style={{fontSize:14,color:C.text,lineHeight:1.6,marginBottom:14}}>{profile.desc}</p>
              {[["📞",profile.tel],["📧",profile.email],["💰",profile.tarif]].map(([ic,v]) => (
                <div key={ic} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 0",borderBottom:`1px solid ${C.border}`}}>
                  <span style={{fontSize:16,width:22}}>{ic}</span>
                  <p style={{fontSize:14,color:C.text,fontWeight:600}}>{v}</p>
                </div>
              ))}
              {prest.certifié && (
                <div style={{marginTop:14,background:"#d1fae5",borderRadius:10,padding:"8px 12px",display:"flex",alignItems:"center",gap:8}}>
                  <span>✅</span>
                  <p style={{fontSize:13,fontWeight:600,color:"#065f46"}}>Prestataire certifié RésiFlow</p>
                </div>
              )}
            </div>
            <div style={{background:C.card,borderRadius:16,padding:24,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
              <h4 style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:16}}>{copy.myProfile}</h4>
              <Inp label="Nom affiché" value={profile.nom} onChange={v => setProfile(p => ({...p, nom:v}))} />
              <Inp label={copy.services} value={profile.services} onChange={v => setProfile(p => ({...p, services:v}))} />
              <Inp label={copy.pricing} value={profile.tarif} onChange={v => setProfile(p => ({...p, tarif:v}))} />
              <Inp label={copy.city} value={profile.ville} onChange={v => setProfile(p => ({...p, ville:v}))} />
              <Inp label="Catégorie" value={profile.cat} onChange={v => setProfile(p => ({...p, cat:v}))} />
              <Inp label="Téléphone" value={profile.tel} onChange={v => setProfile(p => ({...p, tel:v}))} />
              <Inp label="Email" type="email" value={profile.email} onChange={v => setProfile(p => ({...p, email:v}))} />
              <div style={{marginBottom:14}}>
                <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:5,textTransform:"uppercase",letterSpacing:".4px"}}>Description</label>
                <textarea className="inp" rows={4} value={profile.desc} onChange={e => setProfile(p => ({...p, desc:e.target.value}))}
                  style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${C.border}`,fontSize:14,color:C.text,resize:"vertical"}} />
              </div>
              {notice && <div style={{background:"#d1fae5",borderRadius:10,padding:"8px 12px",color:"#065f46",fontSize:13,fontWeight:600,marginBottom:12}}>{notice}</div>}
              <Btn onClick={() => {
                onSaveProfile?.(profile);
                setNotice(copy.profileUpdated);
              }}>{copy.saveProfile}</Btn>
            </div>
          </div>
        )}

        {tab === "stats" && (
          <div className="fi">
            <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:18}}>
              {[["📋","Demandes reçues","12",C.blue],["✅","Missions terminées","9",C.green],["⭐","Note moyenne",`${prest.note}/5`,C.gold],["💰","CA ce mois","18 500 MAD",C.teal]].map(([ic,l,v,color]) => (
                <div key={l} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 0",borderBottom:`1px solid ${C.border}`}}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <span style={{fontSize:18}}>{ic}</span>
                    <p style={{fontSize:14,color:C.text}}>{l}</p>
                  </div>
                  <p style={{fontSize:16,fontWeight:700,color:color}}>{v}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {tab === "abonnement" && (
          <div className="fi">
            {/* Current plan */}
            <div style={{background:`linear-gradient(135deg,${C.navy},#1a2b7a)`,borderRadius:16,padding:24,marginBottom:20}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
                <div>
                  <p style={{color:"rgba(255,255,255,.45)",fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:6}}>Plan actuel</p>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <span style={{fontSize:28}}>{plan.icon}</span>
                    <h3 style={{color:"#fff",fontSize:22,fontWeight:800,fontFamily:"Syne"}}>{plan.label}</h3>
                    {isEssai && <span style={{background:"rgba(14,201,164,.25)",color:C.teal,fontSize:12,fontWeight:700,padding:"3px 10px",borderRadius:20}}>Essai J{trialDay}/14</span>}
                  </div>
                </div>
                {isEssai && (
                  <div style={{textAlign:"right"}}>
                    <p style={{color:"rgba(255,255,255,.45)",fontSize:11,marginBottom:4}}>Expiration dans</p>
                    <p style={{color:trialLeft<=3?C.gold:C.teal,fontSize:24,fontWeight:800,fontFamily:"Syne"}}>{trialLeft}j</p>
                  </div>
                )}
              </div>
              {isEssai && (
                <div style={{background:"rgba(255,255,255,.07)",borderRadius:10,padding:"10px 14px",marginBottom:14}}>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                    <span style={{color:"rgba(255,255,255,.5)",fontSize:11}}>Progression de l'essai</span>
                    <span style={{color:"#fff",fontSize:11,fontWeight:600}}>Jour {trialDay} / 14</span>
                  </div>
                  <div style={{height:6,background:"rgba(255,255,255,.1)",borderRadius:3,overflow:"hidden"}}>
                    <div style={{height:"100%",background:`linear-gradient(90deg,${C.teal},#0ba882)`,width:`${(trialDay/14)*100}%`,borderRadius:3}} />
                  </div>
                </div>
              )}
            </div>

            {/* Plans comparison */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14}}>
              {[
                {plan:"decouverte", price:"Gratuit", period:"",      features:["3 devis / mois","Profil basique","Listing standard","Support email"]},
                {plan:"pro",        price:"149 MAD", period:"/mois", features:["Devis illimités","Profil mis en avant","Badge ⭐ vérifié","Stats détaillées","Support prioritaire"]},
                {plan:"business",   price:"349 MAD", period:"/mois", features:["Tout Pro inclus","Top 3 listing","Bannière 👑 Partenaire","API accès","Rapports personnalisés","Account manager"]},
              ].map(p => {
                const pl = PLANS[p.plan];
                const isCurrent = prest.plan === p.plan || (isEssai && p.plan === "pro");
                return (
                  <div key={p.plan} className="ch" style={{background:C.card,borderRadius:16,padding:22,boxShadow:"0 2px 14px rgba(11,19,51,.06)",border:isCurrent?`2px solid ${pl.color}`:"2px solid transparent",position:"relative"}}>
                    {isCurrent && <div style={{position:"absolute",top:-10,left:"50%",transform:"translateX(-50%)",background:pl.color,color:"#fff",fontSize:10,fontWeight:700,padding:"2px 10px",borderRadius:20,whiteSpace:"nowrap"}}>Plan actuel</div>}
                    <p style={{fontSize:22,marginBottom:8}}>{pl.icon}</p>
                    <h4 style={{fontSize:16,fontWeight:800,color:C.text,marginBottom:4,fontFamily:"Syne"}}>{pl.label}</h4>
                    <div style={{marginBottom:16}}>
                      <span style={{fontSize:24,fontWeight:800,color:pl.color,fontFamily:"Syne"}}>{p.price}</span>
                      <span style={{fontSize:12,color:C.muted}}>{p.period}</span>
                    </div>
                    <div style={{marginBottom:18}}>
                      {p.features.map(f => (
                        <div key={f} style={{display:"flex",alignItems:"center",gap:7,marginBottom:6}}>
                          <span style={{color:pl.color,fontWeight:700,fontSize:13}}>✓</span>
                          <span style={{fontSize:13,color:C.text}}>{f}</span>
                        </div>
                      ))}
                    </div>
                    <button className="btn" onClick={() => alert(`✅ Passage au plan ${pl.label} initié. Redirection vers le paiement sécurisé…`)}
                      disabled={isCurrent && !isEssai}
                      style={{width:"100%",padding:"10px",borderRadius:10,fontWeight:700,fontSize:13,
                        background:isCurrent&&!isEssai?"#e5e7eb":pl.color,
                        color:isCurrent&&!isEssai?C.muted:"#fff",cursor:isCurrent&&!isEssai?"not-allowed":"pointer"}}>
                      {isCurrent&&!isEssai?"Plan actuel":`Choisir ${pl.label}`}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {tab === "demandes" && (
          <div className="fi">
            <div style={{background:C.card,borderRadius:16,boxShadow:"0 2px 14px rgba(11,19,51,.06)",overflow:"hidden"}}>
              <div style={{padding:"17px 22px",borderBottom:`1px solid ${C.border}`}}>
                <h4 style={{fontSize:15,fontWeight:700,color:C.text}}>Demandes reçues</h4>
              </div>
              <table>
                <thead><tr><th>Résidence</th><th>Date</th><th>Description</th><th>Statut</th><th></th></tr></thead>
                <tbody>
                  {demandes.map(d => (
                    <tr key={d.id}>
                      <td style={{fontWeight:600}}>{d.syndic}</td>
                      <td style={{color:C.muted}}>{fmtD(d.date)}</td>
                      <td>{d.desc}</td>
                      <td><Tag s={d.statut} /></td>
                      <td>
                        {d.statut === "En attente" && (
                          <button className="btn" onClick={() => alert("✅ Demande acceptée !")}
                            style={{padding:"5px 11px",background:C.tealL,color:C.teal,borderRadius:8,fontWeight:600,fontSize:12}}>
                            Accepter
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

/* ══════════════════════════════════════
   SYNDIC — SIDEBAR
══════════════════════════════════════ */
